import { $applyNodeReplacement } from 'lexical';

import { VideoNode } from './VideoNode';

export function $createVideoNode(src: string, description?: string): VideoNode {
  return $applyNodeReplacement(new VideoNode(src, description));
}
